<div class="boxed-content" [ngClass]="{'onFeeSplit': onFeeSplit}">
  <header>
    {{ label }}
    <span *ngIf="subLabel"> - {{ subLabel }}</span>
  </header>
  <div class="boxed-content__container">
    <ng-content></ng-content>
  </div>
</div>